import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  show() {
    if (this.element.dataset.phoneShown === "true") return

    this.element.disabled = true

    fetch(this.urlValue, {
      headers: { "Accept": "application/json" }
    })
      .then(response => {
        if (!response.ok) throw new Error("Failed to load phone")
        return response.json()
      })
      .then(data => {
        const link = document.createElement("a")
        link.href = `tel:${data.tel}`
        link.className = `${this.element.className} ds-btn-ghost text-gray-800`.replace("ds-btn-primary", "")
        link.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg><span>${data.display || "Телефон не указан"}</span>`
        this.element.replaceWith(link)
      })
      .catch(() => {
        this.element.textContent = "Не удалось показать номер"
        this.element.disabled = false
      })
  }
}
